import type { PageViewData } from './types';
import { attachOnVolvoCarsAnalyticsGlobal } from './utils/attachOnVolvoCarsAnalyticsGlobal';
import { getPageKey } from './utils/getPageKey';

export class PageViewCache {
  /**
   * @deprecated
   * Use `urlView` instead.
   */
  private pageView:
    | (PageViewData & { previousPageName?: string; previousPageUrl?: string })
    | null;

  /**
   * We're storing the page view data with a url key
   * that ensures that only events from the same page share data.
   */
  private urlView: {
    [key: string]:
      | (PageViewData & {
          previousPageName?: string;
          previousPageUrl?: string;
        })
      | undefined;
  };

  constructor() {
    this.pageView = null;
    this.urlView = {};
  }

  public set(pageView: PageViewData) {
    this.pageView = pageView;
  }

  public setUrlView(pageView: PageViewData) {
    const pageKey = getPageKey();
    this.urlView[pageKey] = pageView;
  }

  public get() {
    return this.pageView;
  }

  public getUrlView() {
    const pageKey = getPageKey();
    return this.urlView[pageKey];
  }

  public reset() {
    this.pageView = null;
    this.urlView = {};
  }
}

// Singleton across apps
export function getPageViewCache() {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.VolvoCarsAnalytics?.pageViewCache) {
    const pageViewCache = new PageViewCache();
    attachOnVolvoCarsAnalyticsGlobal('pageViewCache', pageViewCache);

    return pageViewCache;
  }

  return window.VolvoCarsAnalytics.pageViewCache;
}
